import { TextField, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  updateOrder as onUpdateOrder,
  cancelCustomerOrder as onCancelCustomerOrder,
  offerUnits as onOfferUnits,
} from "../../slices/thunks";
import { useDispatch } from "react-redux";
import { orderStatus } from "../../Components/constants/layout";
import CancelModal from "../CustomerOrders/CancelModal";
import AlertModal from "../../Components/Common/AlertModal";

const OrderProduct = ({ order, updateMo, statusText }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [showRefundConfirm, setShowRefundConfirm] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(order);
  const [quantity, setQuantity] = useState(order.ordQuantity);
  const [itemPrice, setItemPrice] = useState(
    order.ordTotalPrice / order.ordQuantity
  );

  const dispatch = useDispatch();

  const cancelOrder = (orderId, reason, otherReason, message, outOfStock) => {
    const data = {
      ord_id: orderId,
      cancellation_reason: reason,
      cancellation_message: message,
      cancellation_reason_text: otherReason,
      set_out_of_stock: outOfStock,
    };
    dispatch(onCancelCustomerOrder(data));
  };
  const offerUnits = (orderId) => {
    const data = {
      ord_id: orderId,
    };

    dispatch(onOfferUnits(data));
  };

  const saveOrder = () => {
    // Check if quantity is being reduced and order is in ORDERED or SHIPPED status
    if (
      quantity < order.ordQuantity &&
      (order.ordStatus === orderStatus.STATUS_ORDERED ||
        order.ordStatus === orderStatus.STATUS_SHIPPED)
    ) {
      setShowRefundConfirm(true);
      return;
    }

    proceedWithSave();
  };

  const proceedWithSave = () => {
    const data = {
      order: {
        ord_id: order.ordId,
        ord_user_id: order.ordUserId,
        ord_suo_id: order.ordSuoId,
        ord_pro_id: order.ordProId,
        ord_sup_id: order.ordSupId,
        ord_quantity: quantity,
        ord_totalPrice: order.ordTotalPrice,
        ord_totalCost: order.ordTotalCost,
        ord_paymentIntentId: order.ordPaymentIntentId,
        ord_dateCreated: order.ordDateCreated,
        ord_datePurchaseOrder: order.ordDatePurchaseOrder,
        ord_status: order.ordStatus,
      },
      update_moq: updateMo,
    };
    // console.log(data);
    dispatch(onUpdateOrder(data));
    setIsEdit(false);
    setShowRefundConfirm(false);
  };

  const getStatus = () => {
    switch (order.ordStatus) {
      case orderStatus.STATUS_ACTIVE:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-dark text-uppercase bg-warning"
          >
            Pending
          </span>
        );
      case orderStatus.STATUS_ORDERED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-dark text-uppercase bg-success"
          >
            Ordered
          </span>
        );
      case orderStatus.STATUS_CANCELLED:
        return (
          <>
            <span
              style={{ width: "100px" }}
              className="badge text-dark text-uppercase bg-danger "
            >
              Cancelled
            </span>

            <p className="text-muted">{order.ordCancellationReasonText}</p>
          </>
        );
      case orderStatus.STATUS_SHIPPED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-dark text-uppercase bg-success"
          >
            SHIPPED
          </span>
        );
      case orderStatus.STATUS_EXPIRED:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-danger"
          >
            Expired
          </span>
        );
      case orderStatus.STATUS_MOQNOTMET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-warning"
          >
            MOQ Not Met
          </span>
        );
      case orderStatus.STATUS_MOVNOTMET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-warning"
          >
            MOV Not Met
          </span>
        );
      case orderStatus.STATUS_MOQ_MET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            MOQ Met
          </span>
        );
      case orderStatus.STATUS_MOV_MET:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-uppercase text-dark bg-success"
          >
            MOV Met
          </span>
        );
      case 12:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-dark text-uppercase bg-danger"
          >
            Payment failed
          </span>
        );
      default:
        return (
          <span
            style={{ width: "100px" }}
            className="badge text-dark text-uppercase bg-warning  text-dark"
          >
            {" "}
            {order.ordStatus}{" "}
          </span>
        );
    }
  };

  // Only show action buttons when ordStatus is 0, 4, 7, 20, or 21
  const allowedStatuses = [0, 4, 7, 20, 21];
  return (
    <React.Fragment>
      <AlertModal
        show={showRefundConfirm}
        onYesClick={proceedWithSave}
        onNoClick={() => setShowRefundConfirm(false)}
        text={`You are reducing the quantity from ${order.ordQuantity} to ${quantity}. This will result in a refund being issued. Do you want to proceed?`}
      />
      <CancelModal
        show={showCancelOrder}
        onCancelClick={(orderId, reason, otherReason, message, outOfStock) =>
          cancelOrder(order.ordId, reason, otherReason, message, outOfStock)
        }
        onCloseClick={() => setShowCancelOrder(false)}
        order={order}
      />
      <tr>
        <td>
          <div className="d-flex">
            <div className="flex-grow-1 ms-3">
              <h5 className="fs-15">
                <a
                  href="apps-ecommerce-product-details"
                  className="link-primary"
                >
                  {order.ordUserName}
                </a>
              </h5>
              <p className="text-muted mb-0">
                <span className="fw-medium">Order # {order.ordId}</span>
              </p>
              <p className="text-muted mb-0">
                <span className="fw-medium">
                  {moment(order.ordDateCreated).format("MM/DD/YYYY, h:mm a")}
                </span>
              </p>
            </div>
          </div>
        </td>
        <td>{getStatus()}</td>
        <td className="text-end">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(order.ordProdPrice)}
        </td>
        <td className="text-end">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(order.ordProdCost)}
        </td>
        {isEdit ? (
          <td className="text-end flex-grow-0">
            <TextField
              style={{ width: "100px" }}
              id="outlined-number"
              label="Quantity"
              type="number"
              InputProps={{
                inputProps: {
                  type: "number",
                  min: 0,
                  max: order.ordQuantity,
                },
              }}
              InputLabelProps={{ shrink: true }}
              defaultValue={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              variant="outlined"
            />

            <Tooltip title="Save Quantity">
              <button
                className="text-success border-0 bg-transparent p-0"
                onClick={() => saveOrder()}
              >
                <i className="ri-check-line fs-2"></i>
              </button>
            </Tooltip>
            <Tooltip title="Cancel">
              <button
                className="text-danger border-0 bg-transparent p-0"
                onClick={() => setIsEdit(false)}
              >
                <i className="ri-close-circle-fill fs-2"></i>
              </button>
            </Tooltip>
          </td>
        ) : (
          <td className="text-end">{quantity}</td>
        )}
        <td className="fw-medium text-end">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(order.ordTotalCost)}
        </td>
        <td className="fw-medium text-end">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(order.ordTotalPrice)}
        </td>
        {allowedStatuses.includes(order.ordStatus) && (
          <>
            <>
              <td className="text-end">
                <Tooltip title="Edit Order">
                  <button
                    className="text-info border-0 bg-transparent p-0"
                    onClick={() => setIsEdit(true)}
                  >
                    <i className="ri-pencil-fill fs-4"></i>
                  </button>
                </Tooltip>
              </td>
              <td className="text-end">
                <Tooltip title="Offer More Units">
                  <button
                    className="text-info border-0 bg-transparent p-0"
                    onClick={() => offerUnits(order.ordId)}
                  >
                    <i className="ri-mail-line fs-4"></i>
                  </button>
                </Tooltip>
              </td>
            </>
            <td className="text-end">
              <Tooltip title="Cancel Order">
                <button
                  className="text-danger border-0 bg-transparent p-0"
                  onClick={() => {
                    setSelectedOrder(order);
                    setShowCancelOrder(true);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-4"></i>
                </button>
              </Tooltip>
            </td>
          </>
        )}
      </tr>
    </React.Fragment>
  );
};

export default OrderProduct;
